export enum TransmittalStatus {
  Draft = 0,
  Validated = 1,
  PMApproved = 2,
  IssuedToClient = 3,
  ReceiptReceived = 4,
  Cancelled = 5,
  Processing = 6,
  NoReceipt = 7,
  PMConfirmed = 8,
  ReadyForApproval = 9,
  UnofficiallyIssued = 10,
}

export const TransmittalStatusMetadata: {
  [key in TransmittalStatus]: { order: number; description: string; style: string; hidden: boolean };
} = {
  [TransmittalStatus.Draft]: { order: 0, description: 'Draft', style: 'badge-secondary', hidden: true },
  [TransmittalStatus.Validated]: { order: 1, description: 'Validated', style: 'badge-success', hidden: true },
  [TransmittalStatus.PMApproved]: { order: 2, description: 'PM Approved', style: 'badge-primary', hidden: true },
  [TransmittalStatus.IssuedToClient]: { order: 3, description: 'Issued To Client', style: 'badge-info', hidden: false },
  [TransmittalStatus.ReceiptReceived]: {
    order: 4,
    description: 'Receipt Received',
    style: 'badge-inverse',
    hidden: false,
  },
  [TransmittalStatus.Cancelled]: { order: 5, description: 'Cancelled', style: 'badge-danger', hidden: true },
  [TransmittalStatus.Processing]: { order: 6, description: 'Processing', style: 'badge-inprogress', hidden: true },
  [TransmittalStatus.NoReceipt]: { order: 7, description: 'NoReceipt', style: 'badge-noreceipt', hidden: true },
  [TransmittalStatus.PMConfirmed]: { order: 8, description: 'PM Confirmed', style: 'badge-pmconfirmed', hidden: true },
  [TransmittalStatus.ReadyForApproval]: {
    order: 9,
    description: 'Ready For Approval',
    style: 'badge-readyforapproval',
    hidden: true,
  },
  [TransmittalStatus.UnofficiallyIssued]: {
    order: 10,
    description: 'Unofficially Issued',
    style: 'badge-info',
    hidden: true,
  },
};

export const TransmittalStatusSorted = Object.entries(TransmittalStatusMetadata)
  .map(([key, value]) => ({
    status: Number(key) as TransmittalStatus,
    ...value,
  }))
  .filter(x => !x.hidden)
  .sort((a, b) => a.order - b.order);
